/* eslint-disable no-prototype-builtins */

export default class Validate {
    static isEmailValid = email => {
        const emailPattern = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[_a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
        return typeof email === "string" && emailPattern.test(email);
    };
}
